import { useEffect, useState } from "react";
import { ROLE } from "../../utils/constants";
import auth from "../../services/auth";
import v2DashboardApi from "../services/v2DashboardApi";
import { ensureAccountId } from "../session";

export function useClientAISummary() {
  const [aiSummaryData, setAiSummaryData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const role = auth.getUserRole() || auth.getUserDetails()?.roleName;
        const accountId = await ensureAccountId();
        if (cancelled) return;

        if (role && role !== ROLE.Role_Admin) {
          setLoading(false);
          return;
        }
        if (!accountId) {
          setLoading(false);
          return;
        }

        const aiData =
          await v2DashboardApi().getClientAISummaryByAccount(accountId);
        if (!cancelled) setAiSummaryData(aiData?.data || aiData || {});
      } catch {
        if (!cancelled) setAiSummaryData({});
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return { aiSummaryData, loading };
}
